import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=133f6faa&scoped=true&"
import script from "./NameInput.vue?vue&type=script&lang=js&"
export * from "./NameInput.vue?vue&type=script&lang=js&"
import style0 from "./NameInput.vue?vue&type=style&index=0&id=133f6faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f6faa",
  null
  
)

export default component.exports